import React from 'react';
import SentimentDashboard from './components/SentimentDashboard';

function App() {
  return (
    <div className="App">
      <h1 className="text-2xl font-bold mb-4"></h1>
      <SentimentDashboard />
    </div>
  );
}

export default App;